import React from 'react';

export const SetupWorkerState = (isWorking = false, hasError = false, customErrorMessage: string = null) => React.useState<IWorkerState>({isWorking, hasError, customErrorMessage});

export interface IWorkerState {
   isWorking: boolean;
   hasError: boolean;
   customErrorMessage?: string;
}
